/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import yn from 'yn';
import { useQuery } from 'react-query';
import { eventSubject } from '../../../core/events';
import {
  insertChatMessageList,
  setMsgResetClient,
  setMsgClient,
  getClientChat,
  setMsgChatMessages,
  setChatReviewLink,
} from '../../../reducers/messaging';

import Header from './components/Header';
import Messages from './components/Messages';
import ChatInputFooter from './components/ChatInputFooter';
import { DragAndDropContextProvider } from '../../../context/DragDropContext';
import { OptedOutBanner } from './components/OptedOutBanner';
import NoNumberBanner from './components/NoNumberBanner';
import { postRequest, getRequest, getMessageSettings } from '../../../core/apiRequests';
import { notificationSuccess } from '../../../core/actions';
import { setAllStoreConversationHistory, setAuthSelStore } from '../../../reducers/auth';
import { hasUsableContactMethod, hasLoadedContactInfo, shouldShowNoContactMethodBanner } from './Helpers/contactMethod';

function chatComponent({
  setDrawerToggle,
  chatIconColor,
  messaging,
  setAssignPopup,
  paymentBanner,
  type,
  auth,
  setChatMoreRefresh = () => { },
  allStoreConversationHistory,
  loading,
  client,
}) {
  const [contactMethod, setContactMethod] = useState();
  const [hasOptedOut, setHasOptedOut] = useState();
  const [hasNotOptedOut, setHasNotOptedOut] = useState();
  const [hasOptOutDate, setHasOptOutDate] = useState();
  const [unknownNumber, setUnknownNumber] = useState();
  useEffect(() => {
    const subscription = eventSubject.subscribe(event => {
      const findSelectedStore = auth.stores.find(store => store.id === auth.selectedStore);
      if (findSelectedStore.name === event.store_name || findSelectedStore.id === event.storeId) {
        const { client_id } = event;
        if (messaging?.client?.client_id === client_id || messaging?.client?.chat_id === event?.chatId) {
          if (event?.facebookMessageId) {
            insertChatMessageList({
              ...event,
              msg: event.messageText,
              messageUUID: event.chatUuid,
              user_name: event.facebookUserName,
              client_name: event.facebookUserName,
              sent_timestamp: event.sentTimestamp,
              observers: [],
              id: event.chatId,
              type: 'F',
            });
          } else if (event?.instagramMessageId) {
            insertChatMessageList({
              ...event,
              msg: event.messageText,
              user_name: event.instagramUserName,
              client_name: event.instagramUserName,
              messageUUID: event.chatUuid,
              sent_timestamp: event.sentTimestamp,
              observers: [],
              id: event.chatId,
              type: 'I',
            });
          } else {
            insertChatMessageList(event);
          }
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [messaging?.client?.client_id]);

  useEffect(() => {
    if (auth.selectedStore) {
      const reqObj = {
        params: ['chats', auth.selectedStore, 'getReviewLink'],
      };
      (async () => {
        const linkData = await getRequest(reqObj);
        if (linkData.length > 0) {
          const { review_link } = linkData[0];
          setChatReviewLink(review_link);
        }
      })();
    } else {
      console.error('Unable to getReviewLink, NO store ID!');
    }
  }, [auth.selectedStore]);

  useEffect(() => {
    setContactMethod(
      hasUsableContactMethod({
        email: messaging?.email,
        mobile: messaging?.mobile,
        preferredContact: messaging?.preferredContact,
        preferredContactType: messaging?.client?.preferred_contact_type,
      }),
    );
    setHasOptedOut(messaging?.DNC === 1);
    setHasNotOptedOut(messaging?.DNC !== 1);
    setHasOptOutDate(messaging?.optOutDate);
    setUnknownNumber(messaging?.client?.anonymous || false);
  }, [
    messaging?.email,
    messaging?.DNC,
    messaging?.optOutDate,
    messaging?.client,
    messaging?.mobile,
    messaging?.preferredContact,
    messaging?.client?.preferred_contact_type,
    messaging?.client?.name,
    messaging?.client?.anonymous,
  ]);

  const contactInfoLoaded = useMemo(
    () =>
      hasLoadedContactInfo({
        contactInfoClientId: messaging?.contactInfoClientId,
        clientId: messaging?.client?.client_id,
      }),
    [messaging?.contactInfoClientId, messaging?.client?.client_id],
  );

  const clearSelectedClient = () => {
    setMsgResetClient();
    setMsgChatMessages([]);
    setMsgClient({});
    getClientChat({});
    setChatMoreRefresh(true);
  };

  const mergeSelectedClient = () => {
    setChatMoreRefresh(true);
  };

  const limitedVisibility = useMemo(() => {
    const assignedAssociates = messaging?.client?.assignedAssociates;
    const followers = messaging?.client?.followers?.length > 0 ? messaging?.client?.followers : [];
    const associatesAvailable = [...followers.map(follower => Number(follower)), assignedAssociates];
    return yn(auth.merchantConfig.LIMIT_ASSOCIATE_VISIBILITY_ENABLED) &&
      auth.role === 'ASSOCIATE' &&
      !associatesAvailable?.includes(auth.userId);
  }, [auth, messaging?.client]);

  useQuery(
    ['merchant', 'config', auth.merchantId],
    async () => {
      const data = await getMessageSettings('merchant', auth.merchantId);
      if (data) {
        setAllStoreConversationHistory(yn(data.ALL_STORE_CONVERSATION_HISTORY));
      }
    },
    {
      enabled: auth.allStoreConversationHistory === null,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  );

  return (
    <DragAndDropContextProvider
      style={
        type === 'right'
          ? { height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }
          : {}
      }
    >
      <FullChatWrapper newWebNavigation={{}} type={type}>
        <ChatBody
          setAssignPopup={setAssignPopup}
          setDrawerToggle={setDrawerToggle}
          chatIconColor={chatIconColor}
          type={type}
          contactMethod={contactMethod}
          contactInfoLoaded={contactInfoLoaded}
          hasOptedOut={hasOptedOut}
          hasNotOptedOut={hasNotOptedOut}
          hasOptOutDate={hasOptOutDate}
          limitedVisibility={limitedVisibility}
          unknownNumber={unknownNumber}
          messaging={messaging}
          auth={auth}
          clearSelectedClient={clearSelectedClient}
          mergeSelectedClient={mergeSelectedClient}
          allStoreConversationHistory={allStoreConversationHistory}
          loadingConversation={loading}
          client={client}
        />
      </FullChatWrapper>
    </DragAndDropContextProvider>
  );
}

const mapStateToProps = state => ({
  messaging: state.messaging,
  auth: state.auth,
  allStoreConversationHistory: state.auth.allStoreConversationHistory,
  client: state.client
});

export default connect(mapStateToProps)(chatComponent);

const ChatBody = ({
  setAssignPopup,
  setDrawerToggle,
  chatIconColor,
  type,
  contactMethod,
  contactInfoLoaded,
  hasOptedOut,
  hasOptOutDate,
  hasNotOptedOut,
  limitedVisibility,
  unknownNumber,
  messaging,
  auth,
  clearSelectedClient,
  mergeSelectedClient,
  allStoreConversationHistory,
  loadingConversation,
  client
}) => {
  const convType = messaging.client?.type;
  const googleReviewAnswered = messaging.client.clientReplyDateTime !== messaging.client.lastSentTimestamp;
  const facebookConversationClosed = moment().diff(moment(messaging.client.clientReplyDateTime), 'hours') > 168;
  const clientbookConversationUnavailable = !contactMethod || limitedVisibility || hasOptedOut || hasOptOutDate;
  const showNoContactMethodBanner = shouldShowNoContactMethodBanner({
    conversationType: convType,
    contactInfoLoaded,
    hasContactMethod: contactMethod,
    hasNotOptedOut,
  });
  const hideChatInput =
    ((!convType || convType === 'C') && clientbookConversationUnavailable) ||
    (convType === 'G' && googleReviewAnswered) ||
    (convType === 'F' && facebookConversationClosed) ||
    (convType === 'I' && facebookConversationClosed) ||
    messaging?.client?.isBlocked;

  const unblockPhoneNumber = async () => {
    const reqObj = {
      params: ['chats', 'unblockPhoneNumber'],
      data: {
        mobile: messaging.mobile,
      },
    };

    await postRequest(reqObj);

    setMsgClient({ isBlocked: false });
    notificationSuccess('Phone Number Unblocked');
  };

  useEffect(() => {
    if (window.location.pathname.includes('/Clients')) {
      const stores = auth?.stores?.filter(st => st.id !== 0);
      if (client.client_id && stores.length > 1) {
        const clientStoreId = client?.store_id || client?.storeId;
        const findStore = stores.find(store => store.id === clientStoreId);
        if (findStore) {
          setAuthSelStore(clientStoreId);
        } else {
          setAuthSelStore(stores[0].id);
        }
      }
    }
  }, [client.client_id, auth.stores, window.location.pathname]);

  return (
    <>
      <Header
        setAssignPopup={setAssignPopup}
        setDrawerToggle={setDrawerToggle}
        chatIconColor={chatIconColor}
        type={type}
      />
      {hasOptedOut || hasOptOutDate ? <OptedOutBanner /> : null}
      {messaging.client.isBlocked ? (
        <div className="opted-out-banner opted-out-banner-blocked">
          <p>
            <span>This number was blocked by {messaging.client.merchantName}.</span>{' '}
            <i onClick={unblockPhoneNumber}>Unblock number</i>
          </p>
        </div>
      ) : null}
      {convType === 'F' && facebookConversationClosed && (
        <div className="facebook-closed-banner">
          <p>
            <span>Facebook's time limit to respond is 7 days. Your response window has expired.</span>{' '}
          </p>
        </div>
      )}
      {convType === 'I' && facebookConversationClosed && (
        <div className="facebook-closed-banner">
          <p>
            <span>Instagram's time limit to respond is 7 days. Your response window has expired.</span>{' '}
          </p>
        </div>
      )}
      {unknownNumber ? (
        <NoNumberBanner
          messagingClient={messaging.client}
          messagingMobile={messaging.mobile}
          inboxList={messaging.inboxList}
          storeInboxList={messaging.storeInboxList}
          merchantId={auth.merchantId}
          userId={auth.userId}
          role={auth.role}
          pos_type={auth.pos_type}
          sync_clients={auth.sync_clients}
          first_name={auth.first_name}
          last_name={auth.last_name}
          clearSelectedClient={clearSelectedClient}
          mergeSelectedClient={mergeSelectedClient}
        />
      ) : null}
      {showNoContactMethodBanner ? (
        <div className="opted-out-banner opted-out-banner-chat-component">
          <p>No contact method available</p>
        </div>
      ) : null}
      <Messages chatIconColor={chatIconColor} type={type} loadingConversation={loadingConversation} />
      {!hideChatInput ? (
        <ChatInputFooter
          type={type}
          setDrawerToggle={setDrawerToggle}
          allStoreConversationHistory={allStoreConversationHistory}
        />
      ) : (
        <div className="h-64" />
      )}
    </>
  );
};

const FullChatWrapper = ({ children, newWebNavigation, type }) => {
  return type === 'full' ? (
    <div
      className={`conversation-window
        ${newWebNavigation ? 'conversationWindowHeightWithBanner' : 'conversationWindowHeightWithoutBanner'}
      `}
    >
      {children}
    </div>
  ) : (
    children
  );
};
